import {
    ClientPreviewFieldsFragment,
    PatientPreviewFieldsFragment,
} from '~graphql/generated/graphql'

export type SimpleClient = Pick<
    ClientPreviewFieldsFragment,
    'id' | 'first_name' | 'last_name' | 'email' | 'phone' | 'address'
>

export type SimplePatient = Pick<PatientPreviewFieldsFragment, 'id' | 'name'>

export enum DateFormat {
    Date = 'Date',
    Time = 'Time',
    DateTime = 'DateTime',
    DateAtTime = 'DateAtTime',
    /** Friday, August 21st, 2026 at 4:38:09 PM vs Friday, 21 August 2026 at 4:38:09 PM */
    LongDateTime = 'LongDateTime',
}

/** Countries that write the month before the day (M/D/YYYY, "Jul 21st"). */
export const MONTH_FIRST_DATE_COUNTRIES = [
    'United States',
    'Philippines',
    'Belize',
    'Palau',
    'Canada',
] as const

export function usesMonthFirstDateFormat(
    country: string | null | undefined,
): boolean {
    if (!country) return false
    return (MONTH_FIRST_DATE_COUNTRIES as readonly string[]).includes(country)
}

type DateFormatConverter = {
    [key in DateFormat]: string
}

export const UsDateFormatConverter: DateFormatConverter = {
    [DateFormat.Date]: 'M/d/yyyy', // 06/03/2025
    [DateFormat.Time]: 'h:mm a', // 1:00 PM
    [DateFormat.DateTime]: 'M/d/yyyy h:mm a', // 06/03/2025 1:00 PM
    [DateFormat.DateAtTime]: "M/d/yyyy 'at' h:mm a", // 06/03/2025 at 1:00 PM
    [DateFormat.LongDateTime]: "EEEE, MMMM do, yyyy 'at' h:mm:ss a",
}

export const IntlDateFormatConverter: DateFormatConverter = {
    [DateFormat.Date]: 'dd/MM/yyyy',
    [DateFormat.Time]: 'h:mm a',
    [DateFormat.DateTime]: 'dd/MM/yyyy h:mm a',
    [DateFormat.DateAtTime]: "dd/MM/yyyy 'at' h:mm a",
    [DateFormat.LongDateTime]: "EEEE, d MMMM yyyy 'at' h:mm:ss a",
}

export const FallbackDateFormatConverter: DateFormatConverter = {
    [DateFormat.Date]: 'yyyy-MM-dd',
    [DateFormat.Time]: 'h:mm a',
    [DateFormat.DateTime]: 'yyyy-MM-dd h:mm a',
    [DateFormat.DateAtTime]: "yyyy-MM-dd 'at' h:mm a",
    [DateFormat.LongDateTime]: "yyyy-MM-dd HH:mm:ss",
}
